/* eslint-disable */
import images from './images';

const kebab = [
  {
    title: 'kebab',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'cordons bleu',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'merguez',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'steak',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'tenders',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'suplements ',
    price: 'viande +1.5, fromage +1, légumes +0.5, oeuf +0.5)',
  
  },
];
const sandwish = [
  {
    title: 'buffalo',
    price: '7€',
    tags: '2 steaks, oeuf, fromage, Servi Avec Frites ',
  },
  {
    title: 'Radical',
    price: '7.5€',
    tags: '2 steaks, cordon bleu, fromage, Servi Avec Frites ',
  },
  {
    title: 'Volcano',
    price: '8.5€',
    tags: 'Chicken, steaks, fromage, oeuf, Servi Avec Frites ',
  },
  {
    title: 'Toronto',
    price: '8.5€',
    tags: 'Chicken, GPT, fromage, oeuf, Servi Avec Frites ',
  },
  {
    title: 'Savoyard',
    price: '8.5€',
    tags: 'Escalope, champignons, creme fraiche, fromage, Servi Avec Frites ',
  },
  {
    title: 'Triple X ',
    price:'8.5€',
    tags: '3 Steaks, fromage, oeuf, Servi Avec Frites',
  
  },
];




const tacos = [
  {
    title: 'Tacos 1 Viande',
    price: '7.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Tacos 2 Viande',
    price: '8.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Tacos 3 Viande',
    price: '10.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Tacos Veggie',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: '2€ sont ajoutés au prix du tacos si vous souhaitez commander un tacos gratiné ',
    price: '(lardons, raclette, chèvre, miel)',
  
  },
];
const naans = [
  {
    title: 'Naans Steaks',
    price: '6.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Naans Tenders',
    price: '6.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Naans Chicken',
    price: '6.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Naans Kebab',
    price: '6.5€',
    tags: 'Servi Avec Frites ',
  },
  {
    title: 'Naans Merguez',
    price: '6.5€',
    tags: 'Servi Avec Frites ',
  },
 
];
const dessert = [
  {
    title: 'Tarte de Daim',
    price: '2.5€',

  },
  {
    title: 'Tiramisu',
    price: '2.5€',
  
  },
  {
    title: 'Tacos Nutella',
    price: '6€',
    tags: 'Servi Avec Frites ',
  },
 
];
const burger = [
  {
    title: 'Cheese burger',
    price: '3.5€',
    tags: '1 steak, fromage,Servi Avec Frites ',
  },
  {
    title: 'Double Cheese',
    price: '4.5€',
    tags: '2 steak, fromage,Servi Avec Frites ',
  },
  {
    title: 'Big cheese',
    price: '6.8€',
    tags: '1 steak 90 g, Bacon, fromage,Servi Avec Frites ',
  },
  {
    title: 'Country burger',
    price: '6.5€',
    tags: '1 steak 90 g, G.PT, fromage, Servi Avec Frites ',
  },
  {
    title: 'Texas',
    price: '6.5€',
    tags: 'Steak, Raclette, Bacon, Cheddar, Servi Avec Frites ',
  },
  {
    title: 'Brooklyn',
    price: '8.5€',
    tags: 'Steak 180g, bacon, oeuf, fromage, Servi Avec Frites ',
  }
 ,
];
const boisson = [
  {
    title: 'Boisson 33 cl',
    price: '1,5€',
 
  },
  {
    title: 'Boisson 150 cl',
    price: '3.5€',

  },
  {
    title: 'Café',
    price: '1.5€',
  
  },
  {
    title: 'Eau 50 cl',
    price: '1€',

  }
 ,
];
const pizzaTomate = [
  {
    title: '4 fromages',
    price: '6.5€',
    tags: ' Fromage, chèvre, raclette, brie ',
  },
  {
    title: ' Végétarienne ',
    price: '6.5€',
    tags: ' Fromage, olives, poivrons, champignons, oignons ',
  },
  {
    title: 'Reine',
    price: '6.5€',
    tags: ' Fromage, jambon, origans, champignons ',
  },
  {
    title: 'Pêcheur ' ,
    price: '6.5€',
    tags: ' Fromage, thon, olives, oignons, œuf, origans ',
  },
  {
    title: '  Orientale ' ,
    price: '6.5€',
    tags: ' Fromage, merguez, olives, poivrons, œuf ',
  },
  {
    title: 'Kebab',

    price: '6.5€',
    tags: 'Fromage, kebab, origan',
  },
  
];
const salades = [
  
  {
    title: 'César',

    price: '7€',
    tags: 'Salades, Tomates cerise, Fromage, Poulet, Maïs',
  },
  {
    title: 'Chévre',
    price: '7€',
 tags: 'Salades, Tomates cerise, Fromage, Chèvre',
  },
  {
    title: 'Tenders',
    price: '7€',
    tags: 'Salades, Tomates cerise, Fromage, Tenders',
  },
  {
    title: 'Océano',
    price: '7€',
    tags: 'Salades, Tomates cerise, Fromage, Saumon Fumé, Maïs',
  },

];
const pates = [
  
  {
    title: 'Carbonara',

    price: '8€',
    tags: 'Crème Liquide, Lardons, Oeuf',
  },
  {
    title: 'Bolognaise',
    price: '8€',
 tags: 'Sauce Tomate, Viande Hachée',
  },
  {
    title: 'Nordique',
    price: '9€',
    tags: 'Crème Liquide, Saumon fumé, Sauce Volcano',
  },
]
  const paninis = [
  
    {
      title: 'Panini',
  
      price: '5.5€',
      tags: 'Viande au choix, fromage, sauce, servi avec frites',
    },
    {
      title: 'Wings * 5',
      price: '4€',
   
    },
  {
    title: 'Nuggets * 5',
    price: '4€',

  },
  {
    title: 'Tenders * 4',
    price: '5€',

  },
];
const assietes = [
  
  {
    title: '1 Viande',

    price: '9€',
    tags: 'viande, frites, blé, salades, sauce',
  },
  {
    title: '2 Viandes',
    price: '11€',
 tags: '2 viandes, frites, blé, salades, sauce',
  },
  {
    title: '3 Viandes',
    price: '12.5€',
    tags: '3 viandes, frites, blé, salades, sauce',
  },
  {
    title: 'Grillades Mixtes',
    price: '15€',
    tags: 'viandes, frites, blé ou riz, salades, sauce',
  },
];

const pizzaFraiche = [
  
  {
    title: ' Pacifique',

    price: '7€',
    tags: 'FFromage, saumon fumé, pommes de terre',
  },
  {
    title: 'Paysane',
    price: '6.5€',
 tags: 'Fromage, jambon, oignons, pommes de terre',
  },
  {
    title: 'Boursin',
    price: '6.5€',
    tags: 'Fromage, poulet fumé, pommes de terre, Boursin',
  },
  {
    title: 'Chicken ',
    price: '6.5€',
    tags: 'Fromage, poulet mariné, pommes de terre, oignons',
  },
  {
    title: 'Extras  ',
    price: '1€',
    tags:'Jambon, bacon, œuf, chèvre, Boursin, brie, raclette, 1 viande au choix'
  
  },
];



const awards = [
  {
    imgUrl: images.award01,
     subtitle: 'Voivres-lès-le-Mans',
     subtitle3:'Saint-Corneille',
     subtitle2: 'Souillé'
  },
  {
    imgUrl: images.award02,
    subtitle: 'Saint-Jean-dAssé',
    subtitle3:'Fillé',
    subtitle2: 'Sargé'

  },
  {
    imgUrl: images.award03,
  
    subtitle: 'Lavardin',
    subtitle3:'Saint-Mars-la-Brière',
    subtitle2: 'Louplande'
  },
  {
    imgUrl: images.award05,
   
    subtitle: 'Souligné-Flacé',
    subtitle3:'Coulans-sur-Gée',
    subtitle2: 'Ardenay-sur-Mérize'
  },
];

export default { pizzaFraiche,pizzaTomate,burger,naans,awards,tacos,dessert,boisson,kebab,sandwish,pates,salades,assietes,paninis};
